import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PortalExperimentName } from '../../providers/ExperimentProvider'

export type ExperimentValue = 'A' | 'B' | 'C' | 'D' | 'E'

export interface ExperimentsState {
  activeExperiments: Partial<Record<PortalExperimentName, ExperimentValue>>
}

const initialState: ExperimentsState = {
  activeExperiments: {},
}

export const TRIGGER_EXPERIMENT = 'experiments/triggerExperiment'

export const experimentSlice = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    triggerExperiment: (state, action: PayloadAction<[PortalExperimentName, ExperimentValue]>) => {
      const [experiment, value] = action.payload
      state.activeExperiments[experiment] = value
    },
  },
})

export const { triggerExperiment } = experimentSlice.actions
export const experimentsReducer = experimentSlice.reducer
